module.exports = __webpack_public_path__ + "img/erp_tab02_img_r.f96a79e8.png";